import { render, staticRenderFns } from "./PsychoView.vue?vue&type=template&id=8a51ab06&"
import script from "./PsychoView.vue?vue&type=script&lang=js&"
export * from "./PsychoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports